export class OverviewData {
	public dates: Date[];
	public nbOfOrders: number[];
}  